export {Search as Page};

import {useEffect, useRef, useState, useContext} from "preact/hooks";
import {Song} from "../../components/Song.jsx";
import {Helmet} from "react-helmet-async";
import messages from "../../messages/messages.js";
import API_URL, {withSite} from "../../includes/api.js";
import {NotificationContext} from '../../components/NotificationContext.jsx';
import {usePageContext} from '../../hooks/usePageContext.js';
import {getRequestDomain} from '../../../tenant.config.js';

function Search() {

    const {addNotification} = useContext(NotificationContext);
    const pageContext = usePageContext();
    const search = pageContext?.urlParsed?.search ?? {};

    // Seeded from pages/search/+data.shared.js's server fetch (same default sort as sortOption below).
    // Keeps the results grid populated at render instead of empty until the client fetch completes.
    const seededSongs = pageContext?.data?.songs ?? null;
    // Alias-aware: staging (erocthgin.com) canonicalizes to itself, not to prod.
    const domain = getRequestDomain(pageContext?.hostname);
    const isFirstRun = useRef(true);

    const [songs, setSongs] = useState(seededSongs ?? []);
    const [sortOption, setSortOption] = useState('title-ASC');

    const q = search.q ?? '';

    useEffect(() => {
        if (isFirstRun.current) {
            isFirstRun.current = false;
            if (seededSongs !== null) return;
        }

        const [orderBy, orderDir] = sortOption.split('-');
        const type = search.type ?? '';

        fetch(withSite(`${API_URL}/song/search?s=${encodeURIComponent(q)}&orderBy=${orderBy}&orderDir=${orderDir}&type=${encodeURIComponent(type)}`))
            .then(response => response.json())
            .then(data => {
                if (data.code === 200) {
                    setSongs(data.data);
                } else {
                    addNotification(data.message, 'error');
                }
            })
            .catch(() => {
                addNotification('An error occurred while fetching data', 'error');
            });
    }, [q, sortOption]);

    return (
        <section className="text-white">

            <Helmet>
                <title>{messages["SITE.NAME"]} Search | Listen now!</title>
                <meta name="description" content={`Search all your favorite ${messages["SITE.NAME"]} songs`}/>
                <link rel="canonical" href={`https://www.${domain}/search`}/>
            </Helmet>

            <div className="text-center">
                <h1>SEARCH RESULTS</h1>
                <i>'{q}'</i>

                {songs && songs.length > 0 && (
                    <>
                        <div className="my-4 text-left">
                            <label htmlFor="sortOption" className="mr-2">Sort by:</label>
                            <select
                                id="sortOption"
                                value={sortOption}
                                onChange={(e) => setSortOption(e.target.value)}
                                className="px-2 py-1 rounded-lg bg-neutral-800 text-white cursor-pointer">
                                <option value="title-ASC">A-Z</option>
                                <option value="title-DESC">Z-A</option>
                                <option value="date_added-DESC">Newest</option>
                                <option value="date_added-ASC">Oldest</option>
                            </select>
                        </div>

                        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                            {songs.map((song) => (
                                <Song song={song}/>
                            ))}
                        </div>
                    </>
                )}
            </div>
        </section>
    );
}
